"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabContentFriends;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _TabContentFriendsModule = _interopRequireDefault(require("./TabContentFriends.module.scss"));

var _CharacterTable = _interopRequireDefault(require("../../../shared/CharacterTable/CharacterTable"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _inputElements = require("../../../../../inputElements");

var _TabContentFriends = _interopRequireDefault(require("./TabContentFriends.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function TabContentFriends(_ref) {
  var friends = _ref.friends,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var handleOnChangeSelection = (0, _react.useCallback)(function (index) {
    var selectedCharacter = friends[index];
    console.error("TODO", selectedCharacter);
  }, [friends]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentFriendsModule.default.content, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_CharacterTable.default, {
    characters: friends,
    onChangeSelection: handleOnChangeSelection,
    className: _TabContentFriendsModule.default.table
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentFriendsModule.default.buttons
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _inputElements.EButtonType.FRIEND
  }, formatMessage(_TabContentFriends.default.whisper)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _inputElements.EButtonType.FRIEND
  }, formatMessage(_TabContentFriends.default.add)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _inputElements.EButtonType.FRIEND
  }, formatMessage(_TabContentFriends.default.remove))));
}